import React from "react";
import S from "./ChannelList.styled";
import { useTranslation } from "../../hooks";
const NoMessageBox = () => {
    const strings = useTranslation();
    return (React.createElement(S.MessageInfoWrapper, null,
        React.createElement(S.MessageInfo, null, strings.noChannelsMessage)));
};
export default NoMessageBox;
//# sourceMappingURL=NoMessageBox.js.map